import useActionsNewspaperAdvancedForm from './useActionsNewspaperAdvancedForm'

export default useActionsNewspaperAdvancedForm
